@if (percentage) {
	<div class="reviews-percentage hmf-w-100 hmf-text-align-center hmf-subheader-m">
		<span class="hmf-subheader-bold-l">{{ percentage | number: '1.0-0' }}%</span> would recommend to a friend.
	</div>
}